module.exports = __webpack_public_path__ + "img/sliderBtnRight.3f36c5be.svg";